module.exports = __webpack_public_path__ + "assets/img/schuttgart.aea6e4c0.jpg";